import { Group, Text } from '@mantine/core';
import { type ReactElement } from 'react';
import { IoIosArrowDropdown, IoIosArrowDropup } from 'react-icons/io';
import { MdOutlineRemoveCircleOutline } from 'react-icons/md';

export interface Props {
  label: string;
  fields: string[];
  callback: (sort: string[]) => void;
  currentSort: string[];
  align?: 'start' | 'center' | 'end';
}

export const SortHeader = (props: Props): JSX.Element => {
  const { label, fields, callback, currentSort, align = 'start' } = props;

  const hasMatchingField = currentSort.some(sortValue => {
    const prefix = sortValue.replace(/,(asc|desc)$/, ''); // Remove the postfix (asc/desc)
    return fields.includes(prefix);
  });

  const getIcon = (): ReactElement => {
    if (currentSort.length && hasMatchingField) {
      if (currentSort?.some(sortValue => sortValue.includes('desc'))) {
        return <IoIosArrowDropdown size={20} color="#2A74E6" />;
      }
      return <IoIosArrowDropup size={20} color="#2A74E6" />;
    }
    return <MdOutlineRemoveCircleOutline size={20} color="#606060" />;
  };

  const handleClick = (): void => {
    if (currentSort.length && hasMatchingField) {
      if (currentSort?.some(value => value.includes('desc'))) {
        // eslint-disable-next-line n/no-callback-literal
        callback([]);
      } else {
        callback(fields.map(field => `${field},desc`));
      }
    } else {
      callback(fields.map(field => `${field},asc`));
    }
  };

  return (
    <Group className={`flex-nowrap whitespace-nowrap gap-1 justify-${align}`}>
      <Text>{label}</Text>
      <span
        className={`place-items-center cursor-pointer select-none text-${align}`}
        onClick={handleClick}
        data-testid={`sort-${label.toLowerCase().replace(/\s+/g, '-')}`}
      >
        {getIcon()}
      </span>
    </Group>
  );
};
